import { Routes } from '@angular/router';
import { loginGuard } from 'src/app/guard/login.guard';
import { LoginLayoutComponent } from '../layouts/login-layout/login-layout.component';
import { LoginComponent } from '../pages/login/login.component';
import { ForgotPasswordComponent } from '../pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../pages/reset-password/reset-password.component';
import { resetPasswordGuard } from '../guard/reset-password.guard';
import { forgotPasswordGuard } from '../guard/forgot-password.guard';
import { RegisterComponent } from '../pages/register/register.component';

export const PublicLayoutRoutes: Routes = [
  {
    // login page; forgot password and register open as drawers on top of it
    path: '',
    component: LoginComponent,
    children: [
      {
        path: 'login',
        canActivate: [loginGuard],
        children: []
      },
      {
        path: 'forgot-password',
        canActivate: [forgotPasswordGuard],
        component: ForgotPasswordComponent
      },
      {
        path: 'register',
        canActivate: [loginGuard],
        component: RegisterComponent
      }
    ]
  },
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: 'reset-password',
        canActivate: [resetPasswordGuard],
        component: ResetPasswordComponent
      }
    ]
  },
  {
    path: 'admin',
    loadChildren: () => import('../pages/admin/admin.routes').then((m) => m.AdminRoutes)
  }
];
